import { Newsletter } from "../../types/types";
import ListHeader from "../ListHeader";
import NewsletterItem from "./Item";
import styles from "./List.module.css";

interface Props {
  items: Newsletter[];
}

const NewsletterList = ({ items }: Props) => {
  return (
    <table className={styles.table}>
      <thead>
        <ListHeader items={["TITEL", "DATUM", undefined]} wideLayout={true} />
      </thead>
      <tbody>
        {!items.length ? (
          <p>Keine Newsletter vorhanden</p>
        ) : (
          items.map((item) => <NewsletterItem item={item} key={item.title} />)
        )}
      </tbody>
    </table>
  );
};

export default NewsletterList;
